/**
 * Navigation 그룹 브릿지 목데이터
 */

import type { NavigationGroup } from './types'

// Navigation group mock responses
export const navigationMocks: Record<keyof NavigationGroup, any> = {
  close: null,
  fallbackToNativeList: null,
  openExternal: null,
  openViewUrl: null,
  openInAppBrowser: null
}
